var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7143 10.7143C12.7373 10.7143 13.7184 10.3079 14.4417 9.58456C15.1651 8.8612 15.5715 7.88012 15.5715 6.85714C15.5715 5.83416 15.1651 4.85309 14.4417 4.12973C13.7184 3.40638 12.7373 3 11.7143 3C10.6913 3 9.71026 3.40638 8.98691 4.12973C8.26355 4.85309 7.85718 5.83416 7.85718 6.85714C7.85718 7.88012 8.26355 8.8612 8.98691 9.58456C9.71026 10.3079 10.6913 10.7143 11.7143 10.7143V10.7143Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7143 13.2856C13.7602 13.2856 15.7224 14.0984 17.1691 15.5451C18.6158 16.9918 19.4286 18.954 19.4286 20.9999H4C4 18.954 4.81275 16.9918 6.25946 15.5451C7.70617 14.0984 9.66833 13.2856 11.7143 13.2856V13.2856Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.341b37235a21400857635ac51db0a1cf.svg";
export { ForwardRef as ReactComponent };